<template>
    <div class="patchBaselineSearch">
        <Form ref="patchBaselineForm" :model="patchBaselineForm" :rules="ruleValidate">
            <div>
                <Row :gutter="4">
                    <Col span="5">
                        <FormItem prop="accountIdSearchKey">
                            <Select v-model="patchBaselineForm.accountIdSearchKey" filterable :placeholder="$t('patch_management.patch_policy.queryByAccount')"  @on-change="changeAccountId(patchBaselineForm.accountIdSearchKey)" :transfer="true">
                                <Option :value="item.id" v-for="item in accountIdList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="5">
                        <FormItem prop="regionSearchKey">
                            <Select v-model="patchBaselineForm.regionSearchKey" filterable :placeholder="$t('patch_management.patch_policy.queryByRegion')" :transfer="true">
                                <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="5">
                        <Input search v-model="operatingSystemSearchKey" :placeholder="$t('patch_management.patch_policy.queryByOS')"/>
                    </Col>
                    <Col span="5">
                        <Button type="primary" :loading="modal_loading" @click="search('patchBaselineForm')" v-hasPermission="['patchManagement:patchBaselineConfiguration:search_baseline']">{{$t('patch_management.patch_policy.search')}}</Button>
                    </Col>
                </Row>
            </div>
        </Form>
    </div>
</template>
<script>
    import TablePatchBaseline from '../patch_baseline_configuration/TablePatchBaseline'
    var tablePatchBaseline = TablePatchBaseline;
    export default {
        name: 'PatchBaselineSearch',
        data () {
            return {
                patchBaselineForm: {
                    accountIdSearchKey:'',
                    regionSearchKey:''
                },
                modal_loading:false,
                operatingSystemSearchKey:'',
                accountIdList:[], //账号
                regionList:[], //区域
                ruleValidate: {
                    accountIdSearchKey: [
                        { required: true, message: this.$t('alarms.common.pleaseSelectAccount'), trigger: 'change',type:'number' }
                    ],
                    regionSearchKey: [
                        { required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change' }
                    ]
                }
            }
        },
        mounted: function(){
            this.selectAccountByCloudPlatform();
        },
        methods: {
            /**********************账号********************************/
            //查询账号
            selectAccountByCloudPlatform: function(){
                this.$api.account.selectAccountByCloudPlatform("type",0)
                .then(res => {
                    this.accountIdList = res.data;
                })
            },
            // 按账号筛选
            changeAccountId: function(){
                this.patchBaselineForm.regionSearchKey='';
                this.queryAccountRegions();
            },
            /**********************区域********************************/
            //查询地区
            queryAccountRegions: function(){
                this.$api.account.queryAccountRegions("accountId",this.patchBaselineForm.accountIdSearchKey)
                .then(res => {
                    this.regionList = res.data;
                })
            },
            /**********************搜索********************************/
            search: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        tablePatchBaseline.methods.showAll(this.patchBaselineForm.accountIdSearchKey,this.patchBaselineForm.regionSearchKey,this.operatingSystemSearchKey);
                    }
                })
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/patch_baseline_configuration/PatchBaselineSearch.vue